
import { ReactNode } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface PropertyFeatureProps {
  icon: ReactNode;
  title: string;
  description: string;
  className?: string;
}

const PropertyFeature = ({
  icon,
  title,
  description,
  className,
}: PropertyFeatureProps) => {
  return (
    <motion.div
      className={cn(
        "bg-white/70 backdrop-blur-sm border border-cottage-100 rounded-lg p-6 h-full transition-all duration-300 hover:shadow-md hover:bg-white/90",
        className
      )}
      whileHover={{ y: -3 }}
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3 }}
    >
      <div className="text-cottage-600 mb-4">{icon}</div>
      <h3 className="text-lg font-semibold text-cottage-800 mb-2">{title}</h3>
      <p className="text-cottage-600 text-sm">{description}</p>
    </motion.div>
  );
};

export default PropertyFeature;
